// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { head } from "ramda";

const getEncounterStatus = (appointment) =>
  head(appointment?.appointmentEncounter)?.encounter?.status;

export const getAppointmentStatus = (appointment) => {
  const encounterStatus = getEncounterStatus(appointment);
  switch (true) {
    case appointment.status === "booked":
    case appointment.status === "checked-in":
      return "booked";
    case appointment.status === "noshow":
      return "noshow";
    case appointment.status === "cancelled":
      return "cancelled";
    case appointment.status === "fulfilled" && encounterStatus === "planned":
    case appointment.status === "fulfilled" &&
      encounterStatus === "in-progress":
      return "inProgress";
    case appointment.status === "fulfilled" && encounterStatus === "finished":
    case appointment.status === "fulfilled":
    default:
      return "finished";
  }
};
